import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { Box, Chip, Tooltip, Typography } from "@mui/material";

const AWAITING = "Awaiting data";
const HINT = "This metric is not populated yet.";

/** Renders a metric that Mongo does not carry yet, so the layout stays complete. */
export function PendingValue({
  variant = "text",
}: {
  variant?: "text" | "kpi";
}) {
  return (
    <Tooltip title={HINT}>
      <Typography
        component="span"
        sx={{
          color: "text.disabled",
          fontStyle: "italic",
          fontSize: variant === "kpi" ? "1.75rem" : "0.875rem",
          fontWeight: variant === "kpi" ? 700 : 400,
          whiteSpace: "nowrap",
        }}
      >
        {variant === "kpi" ? "--" : AWAITING}
      </Typography>
    </Tooltip>
  );
}

/** Placeholder body for a card whose whole dataset is missing. */
export function PendingCardBody({ hint }: { hint: string }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        py: 4,
        color: "text.disabled",
      }}
    >
      <HourglassEmptyIcon />
      <Chip size="small" label={AWAITING} variant="outlined" />
      <Typography variant="caption" sx={{ textAlign: "center", maxWidth: 240 }}>
        {hint}
      </Typography>
    </Box>
  );
}
